import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';

import type { Locale } from '../enums/Locale';
import { getDayJsLocale } from './dayjs-locale';

const DATE_FORMAT = 'L';

export const localizeDate = (date: string | Dayjs, locale: Locale, format = DATE_FORMAT) => {
  const dayJsDate = dayjs.isDayjs(date) ? date : dayjs(date);
  const dayJsLocale = getDayJsLocale(locale);

  return dayJsDate.locale(dayJsLocale).format(format);
};
